import * as types from './actionType';

export const sendARequest = () => ({ 
  type: types.SEND_A_REQUEST
})

export const finishARequest = () => ({ 
  type: types.FINISH_A_REQUEST,
})